import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareE = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler5') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler5', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Wildy shield!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Wildy shield!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareE}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareE
  
